import React from 'react';
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { useSpot, useSpotValueUpdate } from './spot.context';
import { SaveButton } from './saveButton.component';
import { SpotTimingsForm } from './spotTimings.form';

const DEFAULT_EVERY: CRM.SpotTimingsOccurence[] = [
  9,
  10,
  11,
  12,
  13,
  14,
  15,
].map(hour => ({
  hour: hour,
  minute: 0,
  allowOverBooking: false,
  capacity: 80,
}));

export const ArrivalsForm: React.FC = () => {
  const { spot, save } = useSpot();
  const arrivalsUpdater = useSpotValueUpdate('arrivals');

  return (
    <form onSubmit={save}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                onChange={event => {
                  if (event.target.checked) {
                    arrivalsUpdater({ every: DEFAULT_EVERY });
                  } else {
                    arrivalsUpdater(null);
                  }
                }}
                checked={Boolean(spot.arrivals)}
              />
            }
            label="Ce spot sert de point d'arrivée"
            labelPlacement="end"
          />
        </Grid>
        {spot?.arrivals && (
          <Grid item xs={12}>
            <SpotTimingsForm value={spot.arrivals} onChange={arrivalsUpdater} />
          </Grid>
        )}
        <Grid item xs={12}>
          <SaveButton />
        </Grid>
      </Grid>
    </form>
  );
};
